import React from 'react';
import dateFormat from 'dateformat';

import {defaultTheme} from '@stencil/build-theme';

import HappyNextIcon from '@stencil/icons/src/HappyNextIcon/HappyNextIcon';
import HappyPreviousIcon from '@stencil/icons/src/HappyPreviousIcon/HappyPreviousIcon';

import * as S from './RecentSearchUI.styles';
import useCarousel from '../../../../../shared/hooks/useCarousel';
import {
  CenteredSpaceWrap,
  SectionHeader,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

const RecentSearchUI = ({
  updateQueryCaller,
  updateSelectedPropertyCaller,
  onSearch,
  goHomeSearchesList,
  addDays,
  defaultCheckinOffset,
  defaultCheckoutOffset,
  convertRoomStringToReadable,
  eventMiddlewareForFE,
  sliderClicksGAHandler,
  homePageClicksGAHandler,
}) => {
  const {
    dataList,
    increment,
    decrement,
    rightCursor,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(goHomeSearchesList, 4);

  return (
    <S.RecentSearchOuterWrapper>
      <CenteredSpaceWrap>
        <SectionHeader>Recent Searches</SectionHeader>
        {(goHomeSearchesList && goHomeSearchesList.length > 4 && (
          <S.SliderHeaderArrowWrapInner>
            <S.SliderArrowWrap
              onClick={eventMiddlewareForFE({
                onClick: () => {
                  decrement();
                },
              })}
            >
              <HappyPreviousIcon
                fill={
                  isLeftCursorActive
                    ? defaultTheme.colors.goBrandBlue.base
                    : defaultTheme.colors.goBrandBlue.medium
                }
              />
            </S.SliderArrowWrap>
            <S.SliderArrowWrap
              onClick={eventMiddlewareForFE({
                onClick: () => {
                  increment();
                  sliderClicksGAHandler(`${rightCursor}`);
                },
              })}
            >
              <HappyNextIcon
                fill={
                  isLeftCursorActive
                    ? defaultTheme.colors.goBrandBlue.base
                    : defaultTheme.colors.goBrandBlue.medium
                }
              />
            </S.SliderArrowWrap>
          </S.SliderHeaderArrowWrapInner>
        )) ||
          null}
      </CenteredSpaceWrap>
      <S.RecentSearchSlider>
        <S.RecentSearchInnerWrapper>
          {dataList.map((item, index) => {
            let checkinDate = new Date(item.checkin.date);
            let checkoutDate = new Date(item.checkout.date);
            let currentDate = new Date();
            checkinDate.setHours(0, 0, 0, 0);
            checkoutDate.setHours(0, 0, 0, 0);
            const checkinDateForUI =
              checkinDate.getTime() < currentDate.getTime() ||
              checkinDate.getTime() > checkoutDate.getTime()
                ? addDays(new Date(), defaultCheckinOffset)
                : checkinDate;
            const checkoutDateForUI =
              checkoutDate.getTime() < currentDate.getTime() ||
              checkoutDate.getTime() < checkinDate.getTime()
                ? addDays(new Date(), defaultCheckoutOffset)
                : checkoutDate;

            return (
              <li
                onClick={eventMiddlewareForFE({
                  onClick: () => {
                    updateQueryCaller({
                      checkin: {date: new Date(checkinDateForUI)},
                      checkout: {date: new Date(checkoutDateForUI)},
                      roomString: item?.roomString,
                      destination: item?.destination,
                      partner: item?.partner,
                      country: item?.country,
                    });
                    if (item?.destination?.t === 'hotel') {
                      updateSelectedPropertyCaller({
                        _id: item?.destination._id,
                        n: item?.destination.n,
                      });
                    }
                    onSearch();
                    homePageClicksGAHandler(index);
                  },
                })}
              >
                <S.RecentSearchInfoWrapper>
                  <CenteredSpaceWrap>
                    <S.RecentSearchHotelText>
                      {(item?.destination?.t === 'city' && <S.CityIconWrap />) || (
                        <S.HotelIconWrap />
                      )}
                      {item.destination.n}
                    </S.RecentSearchHotelText>
                    <S.RightArrowNewIconWrap />
                  </CenteredSpaceWrap>
                  <S.RecentSearchDateText>
                    {`${dateFormat(checkinDateForUI, 'mediumDate')} - ${dateFormat(
                      checkoutDateForUI,
                      'mediumDate',
                    )}`}
                  </S.RecentSearchDateText>
                  <S.RecentSearchPaxText>
                    {convertRoomStringToReadable(item.roomString)}
                  </S.RecentSearchPaxText>
                </S.RecentSearchInfoWrapper>
              </li>
            );
          })}
        </S.RecentSearchInnerWrapper>
      </S.RecentSearchSlider>
    </S.RecentSearchOuterWrapper>
  );
};

export default React.memo(RecentSearchUI);
